<template>
  <v-card>
    <v-card-title class="align-center">
      {{ clientPortal.description }}
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <div v-on="on" v-bind="attrs">
            <switch-confirm
              :value.sync="clientPortal.isActive"
              :color="clientPortal.isActive ? 'green' : 'red'"
              v-on:confirm="updatePortal(clientPortal.id)"
              :loading="isLoading"
              :disabled="!isGrantedUser()"
              class="status-switch"
              dense
              no-margin
            >
              <template #confirm-text>
                Êtes-vous sûr.e de vouloir
                {{ !clientPortal.isActive ? "désactiver" : "activer" }}
                ce portail ?
              </template>
            </switch-confirm>
          </div>
        </template>
        <div>
          <span v-if="clientPortal.isActive">Actif</span>
          <span v-else>Inactif</span>
        </div>
      </v-tooltip>
      <v-btn
        v-if="isGrantedUser()"
        color="primary"
        icon
        @click.stop="createClientPortalDialog = true"
        small
      >
        <v-icon small>mdi-pencil</v-icon>
      </v-btn>
      <edit-client-portal-form-dialog
        :client-portal="clientPortal"
        :open.sync="createClientPortalDialog"
        v-if="createClientPortalDialog && isGrantedUser()"
      />
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-alert v-if="clientPortal.isSandboxModeActive" dense type="warning">
        Le client est en mode sandbox, tous les paiements sont FICTIFS !
      </v-alert>
      <v-alert v-if="clientPortal.isShutdown" dense type="error">
        Bulle de silence activée
      </v-alert>
      <v-row>
        <v-col cols="12" md="6">
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ clientPortal.passmanId }}
                </v-list-item-title>
                <v-list-item-subtitle>ID Passman</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <div>
                  <v-btn
                    icon
                    small
                    :href="passwebUrl + clientPortal.passmanId"
                    target="_blank"
                    class="mr-1"
                  >
                    <v-icon class="fill-default">$passman </v-icon>
                  </v-btn>
                  <v-btn
                    small
                    icon
                    :href="toposUrl + clientPortal.passmanId"
                    target="_blank"
                  >
                    <v-icon class="fill-default">$topos </v-icon>
                  </v-btn>
                </div>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" md="6">
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{
                    clientPortal.reference != "" ? clientPortal.reference : "-"
                  }}
                </v-list-item-title>
                <v-list-item-subtitle>ID Externe</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" md="6">
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  <div v-if="clientPortal.group">
                    <router-link
                      :to="{
                        name: 'groupe-details',
                        params: { id: clientPortal.group.id },
                      }"
                      >{{ clientPortal.group.description }}
                    </router-link>
                  </div>
                  <div v-else>-</div>
                </v-list-item-title>
                <v-list-item-subtitle>Groupe</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" md="6">
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ clientPortal.partner.name }}
                </v-list-item-title>
                <v-list-item-subtitle>Partenaire</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" md="6">
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ getInternationalDate(clientPortal.createdAt) }}
                </v-list-item-title>
                <v-list-item-subtitle>Créé le</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" md="6">
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ clientPortal.createdBy }}
                </v-list-item-title>
                <v-list-item-subtitle>Par</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" md="6">
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ getInternationalDate(clientPortal.updatedAt) }}
                </v-list-item-title>
                <v-list-item-subtitle>Mis à jour le</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" md="6">
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ clientPortal.updatedBy }}
                </v-list-item-title>
                <v-list-item-subtitle>Par</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { defineComponent, toRefs } from "@vue/composition-api";
import { useClientPortal } from "@/composables/client-portal";
import { date } from "@/composables/date";
import EditClientPortalFormDialog from "@/components/ClientPortal/EditClientPortalFormDialog.vue";
import SwitchConfirm from "@/components/General/SwitchConfirm.vue";
import { useRoles } from "../../composables/roles";

export default defineComponent({
  components: {
    EditClientPortalFormDialog,
    SwitchConfirm,
  },
  props: {
    clientPortal: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    /* Import des API */
    const { data, updateClientPortal } = useClientPortal();
    const { getInternationalDate } = date();
    const { isGrantedUser } = useRoles();

    const passwebUrl = config.VUE_APP_PASSWEB_URL || "http://localhost:8080";
    const toposUrl = config.VUE_APP_TOPOS_URL || "http://localhost:8080";


    /* Méthodes */
    const updatePortal = async function (idPortal) {
      const formData = {
        passmanId: props.clientPortal.passmanId,
        description: props.clientPortal.description,
        group: props.clientPortal.group ? props.clientPortal.group.id : null,
        isActive: props.clientPortal.isActive,
        useGroupCatalog: props.clientPortal.useGroupCatalog,
        isSandboxModeActive: props.clientPortal.isSandboxModeActive,
        cardPrefix: props.clientPortal.cardPrefix,
        hasMacLocking: props.clientPortal.hasMacLocking,
        proxyNumber: props.clientPortal.proxyNumber,
      };
      Object.assign(data.clientPortalForm, formData);
      await updateClientPortal(idPortal);
    };

    return {
      getInternationalDate,
      ...toRefs(data),
      updatePortal,
      isGrantedUser,
      passwebUrl,
      toposUrl,
    };
  },
});
</script>
